// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "." + {"2957":"81381f68643d449f1e5c","5338":"8fc3373ec013fa296762"}[chunkId] + ".js";
};